import React, { useMemo } from 'react';

import { Form } from '@unform/web';
import { parseISO, format } from 'date-fns';
import PropTypes from 'prop-types';

import { DateTime, Input, Select } from '~/components/Form';
import { t, can, number } from '~/helpers';

import * as S from './styles';

export default function Details({ data, visible }) {
  const status = useMemo(
    () => [
      { label: 'AGUARDANDO RECEBIMENTO ', value: 0 },
      { label: 'RECEBIMENTO INICIADO', value: 1 },
      { label: 'RECEBIMENTO FINALIZADO', value: 2 },
      { label: 'CANCELADA', value: 3 },
    ],
    []
  );

  if (visible)
    return (
      <Form
        onSubmit={undefined}
        initialData={{
          ...data,
          emissaonfe: format(parseISO(data.emissaonfe), 'dd/MM/yyyy HH:mm'),
          qcomnfe: number(data.qcomnfe, 2),
        }}
      >
        <S.Wrapper>
          <Input
            disabled
            name="nfnfe"
            label={t('s.operacao.notafiscalrecebida.nfnotafiscalrecebida')}
          />

          <DateTime
            label={t(
              's.operacao.notafiscalrecebida.dataemissaonfnotafiscalrecebida'
            )}
            name="emissaonfe"
            time
            disabled
          />

          <Input
            disabled
            name="qcomnfe"
            label={t(
              's.operacao.notafiscalrecebida.volumenfnotafiscalrecebida'
            )}
          />

          <Input
            disabled
            name="statusnfestr"
            label={t('s.cadastro.contrato.statuscontrato')}
          />

          {/* <DateTime
            time
            disabled
            name="nfre_data_recebimento"
            label="Data Recebimento"
          />

          <Input
            disabled
            name="nfnotafiscalrecebida"
            label="Nota Fiscal"
            type="number"
          />

          <Input
            disabled
            name="nfre_chave"
            label="Chave Eletrônica"
            type="number"
          />

          <Select disabled name="nfre_status" label="Status" options={status} />

          <Input disabled name="post_desc" label="Posto" />

          <Input disabled name="desc_placa_ct" label="Placa CT" />

          <Input
            disabled
            name="desc_distribuidora"
            label="CNPJ Distribuidora"
          />

          <Input disabled name="desc_volume_nf" label="Volume" />

          <DateTime
            time
            disabled
            name="desc_dt_emissao_nf"
            label="Data Emissão"
          /> */}
        </S.Wrapper>
      </Form>
    );

  return <div />;
}

Details.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  visible: PropTypes.bool.isRequired,
};
